var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMoneyselectOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4 12.0213C18.2939 11.7211 18.1302 11.4481 17.9221 11.2156C17.4795 10.7211 16.8363 10.4099 16.1204 10.4099H14.2494C13.0578 10.4099 12.0918 11.3759 12.0918 12.5676C12.0918 13.5815 12.7978 14.4587 13.7883 14.6753L16.6369 15.2985C17.7466 15.5412 18.5375 16.5246 18.5375 17.6605C18.5375 18.9955 17.4553 20.0785 16.1204 20.0785H14.509C13.4565 20.0785 12.5612 19.4059 12.2293 18.4671",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3148 10.4099V7.99277",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3148 22.4957V20.0785",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9244 35.7085V23.0185C19.9244 22.2172 20.2428 21.4487 20.8094 20.882C21.376 20.3154 22.1445 19.9971 22.9459 19.9971C23.7472 19.9971 24.5157 20.3154 25.0823 20.882C25.649 21.4487 25.9673 22.2172 25.9673 23.0185V29.6657H30.8017C32.0838 29.6657 33.3134 30.175 34.22 31.0817C35.1265 31.9881 35.636 33.2177 35.636 34.5V35.7085",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3168 26.1969C9.26782 26.1969 4.36414 21.2932 4.36414 15.2442C4.36414 9.19521 9.26782 4.29153 15.3168 4.29153C21.3658 4.29153 26.2695 9.19521 26.2695 15.2442C26.2695 15.7527 26.2348 16.2531 26.1678 16.7432",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoneyselectOutline);
export default __webpack_public_path__ + "static/media/icon_money select_outline.9c7bb7572f3bbb8826c461e2c0d85626.svg";
export { ForwardRef as ReactComponent };